import HeroCTA from 'components/HeroCTA'
import { useSelector } from 'react-redux'
import { getMyAffiliates } from 'store/selectors'

export type CTAsContainerProps = {
  ctas: any[]
}

export default function CTAsContainer(props: CTAsContainerProps) {
  const { selectedAffiliate: affiliate } = useSelector(getMyAffiliates)
  const heroCtas = props?.ctas
    ?.filter(
      (cta) =>
        cta.roleVisibility
          .map((s) => s.split('_')[1])
          .some((s) => affiliate?.roles?.includes(s)) ||
        cta.roleVisibility.includes('all'),
    )
    .map((cta) => {
      if (cta.link.url.includes('/tools')) {
        return {
          ...cta,
          link: {
            ...cta.link,
            url: cta.link.url.split('/tools')[1],
          },
        }
      } else {
        return cta
      }
    })

  return (
    <>
      {heroCtas.map((heroCta) => (
        <HeroCTA
          cta={heroCta}
          affiliateRoles={affiliate?.roles}
          key={heroCta.headlineText}
        />
      ))}
    </>
  )
}
